import React from 'react'
import * as THREE from 'three'

import { Colors } from './../../utils/variables'
import { WavesWrapper } from './styles.js'

const SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

const VERTEX = `
    attribute float scale;

    void main() {

        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

        gl_PointSize = scale * ( 300.0 / - mvPosition.z );

        gl_Position = projectionMatrix * mvPosition;

    }
`

const FRAGMENT = `
    uniform vec3 color;

    void main() {

        if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;

        gl_FragColor = vec4( color, 1.0 );

    }
`

class Waves extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            width: (typeof window !== 'undefined') ? window.innerWidth : null,
            height: (typeof window !== 'undefined') ? window.innerHeight : null
        }

    }

    render() {
        return (
            <WavesWrapper ref={(el) => { this.wrapper = el }} ></WavesWrapper>
        )
    }

    componentDidMount() {

        this.count = 0;
        this.mouseX = 500;
        this.mouseY = -350;

        this.windowHalfX = window.innerWidth / 2;
        this.windowHalfY = window.innerHeight / 2;

        window.addEventListener('resize', this.resizeHandler)

        this.init();
        this.animate();

    }

    init() {
        
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
        this.camera.position.z = 1000;

        this.scene = new THREE.Scene();
        this.numParticles = AMOUNTX * AMOUNTY;

        this.positions = new Float32Array(this.numParticles * 3);
        this.scales = new Float32Array(this.numParticles);

        let i = 0, j = 0;

        for (let ix = 0; ix < AMOUNTX; ix++) {

            for (let iy = 0; iy < AMOUNTY; iy++) {

                this.positions[i] = ix * SEPARATION - ((AMOUNTX * SEPARATION) / 2); // x
                this.positions[i + 1] = 0; // y
                this.positions[i + 2] = iy * SEPARATION - ((AMOUNTY * SEPARATION) / 2); // z

                this.scales[j] = 1;

                i += 3;
                j++;

            }

        }
        
        this.geometry = new THREE.BufferGeometry();
        this.geometry.addAttribute('position', new THREE.BufferAttribute(this.positions, 3));
        this.geometry.addAttribute('scale', new THREE.BufferAttribute(this.scales, 1));

        this.material = new THREE.ShaderMaterial({
            uniforms: {
                color: {value: new THREE.Color(Colors.blue)},
            },
            vertexShader: VERTEX,
            fragmentShader: FRAGMENT
        });

        this.particles = new THREE.Points(this.geometry, this.material);
        this.scene.add(this.particles);
        
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, this.wrapper.clientHeight * 1.8);

        this.wrapper.appendChild(this.renderer.domElement);
    
    }

    animate() {

        requestAnimationFrame(this.animate.bind(this));

        this.camera.position.x += (this.mouseX - this.camera.position.x) * .05;
        this.camera.position.y += (- this.mouseY - this.camera.position.y) * .05;
        this.camera.lookAt(this.scene.position);

        this.positions = this.particles.geometry.attributes.position.array;
        this.scales = this.particles.geometry.attributes.scale.array;

        let i = 0, j = 0;

        for (let ix = 0; ix < AMOUNTX; ix++) {

            for (let iy = 0; iy < AMOUNTY; iy++) {

                this.positions[i + 1] = (Math.sin((ix + this.count) * 0.3) * 50) + (Math.sin((iy + this.count) * 0.5) * 50);
                this.scales[j] = (Math.sin((ix + this.count) * 0.3) + 1) * 8 + (Math.sin((iy + this.count) * 0.5) + 1) * 8;

                i += 3;
                j++;

            }

        }

        this.particles.geometry.attributes.position.needsUpdate = true;
        this.particles.geometry.attributes.scale.needsUpdate = true;

        this.renderer.render(this.scene, this.camera);

        this.count += 0.1;

    }

    resizeHandler = () => {

        this.windowHalfX = window.innerWidth / 2;
        this.windowHalfY = window.innerHeight / 2;

        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, this.wrapper.clientHeight * 1.8);

    }

    componentWillUnmount() {

        window.removeEventListener('resize', this.resizeHandler);

    }


}

export default Waves;